import updateTime from "./epics/updateTime";

export default store => {
  const timer = setInterval(() => store.dispatch(updateTime()), 1000);
  return () => clearInterval(timer);
};



// WEBPACK FOOTER //
// ./src/store/timer.js